import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { StickyBar } from "./StickyBar";

export const Layout = () => (
  <div className="min-h-screen bg-[#0D0E11] text-gray-200 font-body">
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
    <StickyBar />
  </div>
);
